export enum ConditionTypes {
  RATING = 'RATING',
  WORD_COUNT = 'WORD_COUNT',
  REGEX = 'REGEX',
}

export const conditionLabels = {
  [ConditionTypes.RATING]: 'Rating',
  [ConditionTypes.WORD_COUNT]: 'Word Count',
  [ConditionTypes.REGEX]: 'Contains Phrase',
};

export enum ComparatorTypes {
  GT = 'GT',
  GTE = 'GTE',
  LT = 'LT',
  LTE = 'LTE',
  EQ = 'EQ',
  NEQ = 'NEQ',
}

export const comparatorLabels = {
  [ComparatorTypes.GT]: 'Greater than',
  [ComparatorTypes.GTE]: 'Greater than or equal',
  [ComparatorTypes.LT]: 'Less than',
  [ComparatorTypes.LTE]: 'Less than or equal',
  [ComparatorTypes.EQ]: 'Equal to',
  [ComparatorTypes.NEQ]: 'Not equal to',
};

export const ratingOptions = new Array(6).fill(0).map((_, idx) => ({
  label: `${idx} star${idx > 1 ? 's' : ''}`,
  value: idx,
}));

export const conditionOptions = Object.entries(conditionLabels).map(
  ([value, label]) => ({
    label,
    value,
  }),
);

export const comparatorOptions = Object.entries(comparatorLabels).map(
  ([value, label]) => ({
    label,
    value,
  }),
);

export const conditionPrefix: {
  [condition in ConditionTypes]: string;
} = {
  [ConditionTypes.REGEX]: 'Contains',
  [ConditionTypes.RATING]: 'Is',
  [ConditionTypes.WORD_COUNT]: 'Is',
};
